<template>
  <v-main class="cppsbg">
    <app-navigation />
    <v-sheet class="ukpl-blue-card-container" id="scrolling-techniques-7" height="100%">
      <v-container fluid height="100%">
        <v-row justify="center" align="center" class="row">
          <v-col cols="6" sm="6" md="6" xs="6" class="text-center">
            <v-text-field label="First Name" v-model="userDetails.firstname" disabled />
          </v-col>
          <v-col cols="6" sm="6" md="6" xs="6" class="text-center">
            <v-text-field label="Last Name" v-model="userDetails.lastname" disabled />
          </v-col>
        </v-row>
        
        <v-row justify="center" align="center" class="row" v-if="paydisabled">
          <v-col cols="12" sm="12" md="12" xs="12" class="text-center">
            <v-banner>
              <v-avatar slot="icon" color="deep-purple accent-4" size="40">
                <v-icon icon="mdi-account-alert" color="white">
                  mdi-account-alert
                </v-icon>
              </v-avatar>
              Payments are currently disabled for the year. You will be able to
              pay for next year soon.
            </v-banner>
          </v-col>
        </v-row>
        
        <v-row justify="center" align="center" class="row" v-if="!userComplete && !paydisabled && !loading">
          <v-col cols="12" sm="12" md="12" xs="12" class="text-center">
            <v-banner>
              <v-avatar slot="icon" color="deep-purple accent-4" size="40">
                <v-icon icon="mdi-account-alert" color="white">
                  mdi-account-alert
                </v-icon>
              </v-avatar>
              Please go to the Profile page and make sure you have completed all
              details, including UKPSF number, Division, and Team, and uploaded
              a valid photograph. Also please ensure you have signed the
              disclaimer on the disclaimer page.
            </v-banner>
          </v-col>
        </v-row>
        
        <v-row justify="center" align="center" class="registration-wrapper row" v-if="userComplete && !paydisabled && !loading">
          <v-col cols="12" class="text-center">
            <div v-if="userDetails.cardpurchase === 0">
              <h1 class="main-title">{{ currentyear > 0 ? currentyear : new Date().getFullYear() }} PLAYER ID REGISTRATION</h1>
              <h2 class="sub-title">Official League Membership – £20</h2>
              <p class="supporting-text">
                Required for participation in all CPPS & ECPL events during the {{ currentyear > 0 ? currentyear : new Date().getFullYear() }} season
              </p>
            </div>

            <div class="card-preview d-flex justify-center" v-if="userDetails.cardpurchase === 0">
              <v-img src="@/assets/card-sample.png" max-width="320" class="card-image"></v-img>
            </div>

            <div class="info-box shadow-panel" v-if="userDetails.cardpurchase === 0">
              <div class="info-header">
                <h3 class="info-title">WHAT HAPPENS NEXT?</h3>
              </div>
              <div class="info-content">
                <p>
                  <strong>First-time registrations:</strong><br />
                  Your ID card will be available for collection at your next official CPPS or ECPL event you attend.
                </p>
                <p>
                  <strong>Renewals:</strong><br />
                  Once payment is confirmed and your {{ currentyear > 0 ? currentyear : new Date().getFullYear() }} registration is activated, your existing ID card remains valid.
                </p>
              </div>
            </div>

            <div class="payment-section" v-if="userDetails.cardpurchase === 0">
              <div class="divider">
                <span class="divider-text">PAYMENT</span>
              </div>
              <p class="payment-subtitle">Registration activates immediately upon successful payment.</p>

              <div v-show="!paymentProcessing" id="paypal-button-container" class="paypal-container"></div>
              
              <!-- Processing State -->
              <div v-if="paymentProcessing" class="paypal-processing">
                <v-progress-circular indeterminate color="blue" size="64" width="6" class="mb-4"></v-progress-circular>
                <h3 class="info-title">Processing Payment...</h3>
                <p class="secure-note mt-2"><strong>Please do not close this window.</strong><br/>We are securely recording your membership transaction in our system.</p>
              </div>
              
              <!-- Success State -->
              <div v-if="paymentSuccess" class="paypal-success">
                <v-icon color="green" size="64">mdi-check-circle</v-icon>
                <h3 class="info-title mt-4">Thank you for your payment!</h3>
                <p class="secure-note mt-2">Your registration is now active. Generating your Digital ID...</p>
              </div>

              <p class="secure-note" v-if="!paymentProcessing && !paymentSuccess">
                All payments are processed securely. CPPS / ECPL does not store your payment details.
              </p>
              <v-alert v-if="paymentError" type="error" class="mt-4">
                {{ paymentErrorMsg }}
              </v-alert>
              <div class="bottom-divider"></div>
            </div>

            <!-- Digital ID / QR Code Section (Visible only when paid) -->
            <div class="digital-id-section" v-if="userDetails.cardpurchase > 0">
              <div class="divider">
                <span class="divider-text">YOUR DIGITAL ID Pass</span>
              </div>
              
              <div class="digital-pass-card">
                 <div class="pass-header">
                    <h2>{{ userDetails.firstname }} {{ userDetails.lastname }}</h2>
                    <p>UKPSF: {{ userDetails.ukpsf }}</p>
                 </div>
                 
                 <div class="pass-qr-wrapper">
                    <!-- The QR Canvas -->
                    <canvas id="qrcode-canvas" class="qr-canvas"></canvas>
                    <!-- Center Overlay Logo -->
                    <img src="@/assets/ukpl-logo-new.png" class="qr-logo-overlay" alt="UKPL Logo" />
                 </div>
                 
                 <div class="pass-footer">
                    <p class="pass-season">{{ currentyear > 0 ? currentyear : new Date().getFullYear() }} ACTIVE PLAYER</p>
                 </div>
              </div>
              
              <p class="secure-note mt-4">
                Present this QR code at reception to sign in quickly if you do not have your physical card.
              </p>
              <div class="bottom-divider"></div>
            </div>

          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </v-main>
</template>

<script>
import UserService from "../services/user.service";
import UserDetails from "../model/userdetails";
import UtilService from "../services/util.service";
import { loadScript } from "@paypal/paypal-js";
import QRCode from "qrcode";

import AppNavigation from "../components/AppNavigation";

export default {
  name: "IdCard",
  components: {
    AppNavigation,
  },
  data: () => ({

    paydisabled: false,
    userDetails: new UserDetails(),
    currentyear: 0,
    selectdiv: undefined,
    selectteam: undefined,
    loading: true,
    paypalRendered: false,
    allDisclaimersSigned: false,
    paymentProcessing: false,
    paymentSuccess: false,
    paymentError: false,
    paymentErrorMsg: "",
  }),
  computed: {
    chargeValue() {
        return 20;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    userComplete() {
      let isBasicComplete = 
        this.isPopulated(this.userDetails.username) &&
        this.isPopulated(this.userDetails.firstname) &&
        this.isPopulated(this.userDetails.lastname) &&
        this.isPopulated(this.userDetails.gender) &&
        this.userDetails.isOver18 !== null && this.userDetails.isOver18 !== undefined &&
        this.isPopulated(this.userDetails.contactNumber) &&
        this.isPopulated(this.userDetails.addressline1) &&
        this.isPopulated(this.userDetails.town) &&
        this.isPopulated(this.userDetails.postcode) &&
        this.isPopulated(this.userDetails.ukpsf) &&
        this.isPopulated(this.selectdiv) &&
        this.isPopulated(this.selectteam) &&
        this.isPopulated(this.userDetails.file) &&
        this.isPopulated(this.userDetails.emergencycontactname) &&
        this.isPopulated(this.userDetails.emergencycontactnumber) &&
        this.allDisclaimersSigned;

      if (!isBasicComplete) {
        return false;
      }

      if (this.userDetails.isOver18 === false) {
        if (!this.isPopulated(this.userDetails.parentRelationship) ||
            !this.isPopulated(this.userDetails.parentContactNumber) ||
            !this.isPopulated(this.userDetails.parentEmail)) {
          return false;
        }
      }

      return true;
    },
  },
  watch: {
    // Watch for when the PayPal button should be rendered
    userComplete(newVal) {
      if (newVal && !this.paydisabled && !this.loading) {
        if (this.userDetails.cardpurchase === 0) {
          this.$nextTick(() => { this.renderPaypalButton(); });
        } else {
          this.$nextTick(() => { this.generateQRCode(); });
        }
      }
    },
    paydisabled(newVal) {
      if (!newVal && this.userComplete && !this.loading) {
        this.$nextTick(() => { this.renderPaypalButton(); });
      }
    },
    loading(newVal) {
      if (!newVal && this.userComplete && !this.paydisabled) {
        if (this.userDetails.cardpurchase === 0) {
          this.$nextTick(() => { this.renderPaypalButton(); });
        } else {
          this.$nextTick(() => { this.generateQRCode(); });
        }
      }
    },
    // Watch if user suddenly gets a cardpurchase (i.e. success flow completes)
    'userDetails.cardpurchase'(newVal) {
       if (newVal > 0 && this.userComplete && !this.loading) {
          this.$nextTick(() => { this.generateQRCode(); });
       }
    }
  },
  methods: {
    initCurrentYear() {
      UtilService.getCurrentYear().then(
        (response) => {
          this.currentyear = response.data.year;
        },
        (error) => {
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },

    isPopulated(userfield) {
      if (
        typeof userfield !== "undefined" &&
        userfield !== "" &&
        userfield != null
      ) {
        return true;
      } else {
        return false;
      }
    },
    reloadTeams(sel) {
      this.initializeTeams(sel.id);
    },

    initUser() {
      UserService.getUserDetails().then(
        (response) => {
          this.userDetails.id = response.data.id;
          this.userDetails.username = response.data.username;
          this.userDetails.email = response.data.email;
          this.userDetails.password = response.data.password;
          this.userDetails.firstname = response.data.firstname;
          this.userDetails.lastname = response.data.lastname;
          this.userDetails.gender = response.data.gender;
          this.userDetails.isOver18 = response.data.isOver18;
          this.userDetails.contactNumber = response.data.contactNumber;
          this.userDetails.addressline1 = response.data.addressline1;
          this.userDetails.addressline2 = response.data.addressline2;
          this.userDetails.town = response.data.town;
          this.userDetails.county = response.data.county;
          this.userDetails.postcode = response.data.postcode;
          this.userDetails.file = response.data.file;
          this.userDetails.ukpsf = response.data.ukpsf;
          this.userDetails.cardpurchase = response.data.cardpurchasecount;
          this.userDetails.teamcaptain = response.data.teamcaptain;
          this.userDetails.disclaimer = response.data.disclaimer;
          this.userDetails.emergencycontactname = response.data.emergencyContactName;
          this.userDetails.emergencycontactnumber = response.data.emergencyContactNumber;
          this.userDetails.parentRelationship = response.data.parentRelationship;
          this.userDetails.parentContactNumber = response.data.parentContactNumber;
          this.userDetails.parentEmail = response.data.parentEmail;

          let disclaimersSigned = true;
          let activeLeagueCount = 0;

          for (const historyIdx in response.data.userHistory) {
            const history = response.data.userHistory[historyIdx];
            if (this.currentyear === parseInt(history.year)) {
              if (!this.selectdiv) this.selectdiv = history.division.id;
              if (!this.selectteam) this.selectteam = history.team.id;
              activeLeagueCount++;
              if (!history.disclaimer) {
                disclaimersSigned = false;
              }
            }
          }
          if (activeLeagueCount === 0) disclaimersSigned = false;
          this.allDisclaimersSigned = disclaimersSigned;


          //          this.userDetails.divid = response.data.division.id;
          //          this.userDetails.teamid = response.data.team.id;
          this.loading = false;
        },
        (error) => {
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          this.loading = false;
        }
      );
    },
    createOrder(data, actions) {
      return actions.order.create({
              purchase_units: [
                {
                  description: "UKPL Membership Card",
                  amount: { currency_code: "GBP", value: this.chargeValue },
                },
              ],
            });
    },
    renderPaypalButton() {
      // Prevent duplicate renders
      if (this.paypalRendered) return;
      const container = document.getElementById("paypal-button-container");
      if (!container) return; // Ensure element exists first (v-if rendered)

      this.paypalRendered = true;
      if (container.children.length > 0) return;
      loadScript({
        "client-id":
          process.env.NODE_ENV === "production"
            ? "AayKqfNsIRKcEEI8BspYWkvB-GnS6hr7kaQ0lUSJvKV1FfR5lDZtpUhLd007cYUYglzThQi2qe9I8xGN"
            : "ASPHXNm8FKPYa3evAt4K9tboaks_g44vwVrkdwXg-xgxZ8qFTq_2e2mTmAyjNrkk9P-uXPOq1VBYiaqB",
        currency: "GBP",
      }).then((paypal) => {
        // Re-check container exists — user may have navigated away while PayPal SDK was loading
        if (!document.getElementById("paypal-button-container")) return;
        paypal
          .Buttons({
            style: {
              shape: "pill",
              color: "blue",
              layout: "vertical",
              label: "paypal",
            },
            createOrder: this.createOrder,
            onApprove: (data, actions) => {
              return actions.order.capture().then(async (orderData) => {
                // Full available details
                console.log(
                  "Capture result",
                  orderData,
                  JSON.stringify(orderData, null, 2)
                );
                
                // Show processing indicator
                this.paymentProcessing = true;
                this.paymentError = false;

                try {
                  // Must await the backend so the user does not close the window down before it fires off the network request
                  await UserService.purchaseCard(orderData);
                  
                  // Hide processing and show success
                  this.paymentProcessing = false;
                  this.paymentSuccess = true;
                  
                  // Refresh user data (if necessary, though they just paid so they're fully registered)
                  this.initUser();
                } catch (err) {
                  console.error("Failed to update backend after successful PayPal payment", err);
                  this.paymentProcessing = false;
                  this.paymentError = true;
                  this.paymentErrorMsg = "Your payment was successful with PayPal, but we encountered an error updating our records. Please contact support with your PayPal Transaction ID: " + orderData.id;
                }
              });
            },
            onError: (err) => {
              console.log(err);
              this.paymentError = true;
              this.paymentErrorMsg = "There was an error initializing or processing PayPal: " + err;
            },
          })
          .render("#paypal-button-container");
      });
    },

    // Fetches a server-side SHA-256 hash for the QR code.
    // The salt never reaches the browser — it lives in UKPL_SECRET_SALT on the server.
    async generateSecureHash() {
       const response = await UserService.getIdCardHash();
       return response.data.hash;
    },

    async generateQRCode() {
       const canvas = document.getElementById("qrcode-canvas");
       if (!canvas) return; // Wait until DOM updates
       
       try {
         // Generate the secure validation hash
         const hash = await this.generateSecureHash();
         
         // Generate the JSON payload string
         const payload = JSON.stringify({
           id: this.userDetails.id,
           hash: hash
         });
         
         // Build the QR Code Canvas
         QRCode.toCanvas(canvas, payload, {
           width: 250,
           margin: 2,
           color: {
             dark: "#000000",
             light: "#ffffff"
           },
           errorCorrectionLevel: 'H' // High error correction to allow for center logo overlay
         }, function (error) {
           if (error) console.error("Error generating initial QR code", error);
         });
       } catch (err) {
         console.error("Failed to generate Secure ID string", err);
       }
    }

  },
  async created() {
    // Must await year BEFORE loading user — initUser() filters history by this.currentyear,
    // so if both fire simultaneously currentyear is still 0 and no history records match,
    // causing allDisclaimersSigned = false and userComplete = false (payment banner instead of payment form).
    try {
      const yearResp = await UtilService.getCurrentYear();
      this.currentyear = yearResp.data.year;
    } catch (error) {
      this.message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    }
    this.initUser();
  },
  mounted() {
    if (this.userComplete && !this.paydisabled && !this.loading) {
      if (this.userDetails.cardpurchase === 0) {
        this.$nextTick(() => { this.renderPaypalButton(); });
      } else {
        this.$nextTick(() => { this.generateQRCode(); });
      }
    }
  },
};
</script>

<style scoped>
.registration-wrapper {
  max-width: 800px;
  margin: 60px auto;
  text-align: center;
  color: #ffffff;
}

.main-title {
  font-size: 40px;
  font-weight: 800;
  margin-bottom: 10px;
}

.sub-title {
  font-size: 22px;
  margin-bottom: 10px;
  color: #dcdcdc;
}

.supporting-text {
  margin-bottom: 40px;
  color: #c5d0e0;
}

.card-preview {
  margin-bottom: 40px;
}

.card-image {
  box-shadow: 0 20px 40px rgba(0,0,0,0.4);
  border-radius: 8px;
}

.info-box {
  background: rgba(255,255,255,0.05);
  border-radius: 12px;
  margin-bottom: 40px;
  text-align: left;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
  overflow: hidden;
}

.info-header {
  background: rgba(255,255,255,0.1);
  padding: 15px 30px;
  border-bottom: 1px solid rgba(255,255,255,0.05);
}

.info-title {
  font-size: 18px;
  margin: 0;
  font-weight: 700;
  text-align: center;
  letter-spacing: 1px;
}

.info-content {
  padding: 30px;
}

.info-content p {
  margin-bottom: 15px;
  line-height: 1.6;
}

.info-content p:last-child {
  margin-bottom: 0;
}

.payment-section {
  padding-top: 20px;
  position: relative;
}

.divider {
  display: flex;
  align-items: center;
  text-align: center;
  margin-bottom: 20px;
}

.divider::before,
.divider::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.divider-text {
  padding: 0 15px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #ffffff;
}

.bottom-divider {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 30px;
  margin-bottom: 20px;
}

.payment-subtitle {
  color: #c5d0e0;
  margin-bottom: 30px;
}

.paypal-container, .paypal-processing, .paypal-success {
  max-width: 400px;
  margin: 0 auto;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.secure-note {
  font-size: 14px;
  color: #b0bdd3;
  margin-top: 20px;
}

/* Digital ID Styling */
.digital-id-section {
  padding-top: 20px;
}

.digital-pass-card {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 16px;
  max-width: 320px;
  margin: 0 auto;
  padding: 24px;
  box-shadow: 0 15px 35px rgba(0,0,0,0.5), inset 0 0 0 2px rgba(255,255,255,0.2);
  color: #1a237e;
  position: relative;
  overflow: hidden;
}

.pass-header {
  border-bottom: 2px solid rgba(26,35,126,0.1);
  padding-bottom: 16px;
  margin-bottom: 20px;
}

.pass-header h2 {
  font-size: 24px;
  font-weight: 800;
  margin: 0 0 4px 0;
  text-transform: uppercase;
}

.pass-header p {
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  color: #3949ab;
}

.pass-qr-wrapper {
  position: relative;
  display: inline-block;
  background: white;
  padding: 8px;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0,0,0,0.1);
}

.qr-canvas {
  display: block;
}

.qr-logo-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50px;
  height: auto;
  background: white;
  border-radius: 5px;
  padding: 2px;
}

.pass-footer {
  margin-top: 24px;
  background: #1a237e;
  color: white;
  padding: 10px;
  border-radius: 8px;
}

.pass-season {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1px;
}
</style>
